import { Component, OnInit, OnDestroy, NgZone, EventEmitter, Input, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

import { Subscription } from 'rxjs';

import {
    AuthorizationService,
    PresetService,
    Preset,
    PresetDocument,
    Document,
    GlobalService,
    DeleteConfirmation,
    ToastrService
} from './../../../../shared/index';

@Component({
    selector: 'preset-entity',
    templateUrl: './preset-entity.html',
    standalone: false
})

export class PresetEntityComponent implements OnInit, OnDestroy {
    @Input('preset') preset: Preset = new Preset();
    @Input('documentsVisible') documentsVisible = false;

    public subscriptions: Subscription[] = [];
    public textColor = '';
    public Document: Document[] = [];

    public processing = false;
    public isDocumentPage = false;

    public presetId: number;
    public presetName: string;
    constructor(
        private _ngZone: NgZone,
        private _presetService: PresetService,
        private _globalService: GlobalService,
        private _toastrService: ToastrService,
    ) {

        this.subscriptions.push(this._presetService.presetDocuments.subscribe((data: any) => {
            if (data.PresetDocuments.length > 0) {
                this._ngZone.run(() => {
                    const documents: Document[] = [];
                    for (const presetDocument of data.PresetDocuments) {
                        if (presetDocument.PresetId == this.preset.Id) {
                            documents.push($.extend(new Document(), presetDocument.Document));
                        }
                    }
                    this.Document = documents;

                    this.documentsVisible = (this.Document.length > 0);
                });
            }
            else {
                this.Document = [];
                this.documentsVisible = (data.PresetId == this.preset.Id);
            }
            this.processing = false;
        }));
    }

    ngOnInit(): void {
        this.presetName = this.preset.PresetName;
        this.presetId = this.preset.Id;
    }


    public transferDataSuccess($event: any): void {
        const docIds: number[] = [];
        for (const doc of $event.previousContainer.data.Data) {
            this.processing = true;
            docIds.push(doc.Id);
        }
        this._presetService.associateDocumentsToPreset(this.preset.Id, docIds);
    }


    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    public getPresetDocuments(presetId: number): void {
        if (!this.documentsVisible) {
            this.processing = true;
            this._presetService.getPresetDocuments(presetId, false);
        }
        this.documentsVisible = !this.documentsVisible;
    }

    public DeletePreset(presetId: number): void {
        if (confirm('Do you want to delete the preset?') == true) {
            this._presetService.DeletePreset(presetId);
        }
    }

    public ClonePreset(presetId: number): void {
        const newPresetName = prompt('Enter new preset name:', '');

        if (newPresetName == null || newPresetName == '') {
            alert('Please enter new preset name to clone.');
        }
        else {
            this._presetService.ClonePreset(presetId, newPresetName);
        }
    }

    public DeletePresetDocument(presetId: number, presetDocumentId: number): void {
        if (confirm('Do you want to delete the document from preset?') == true) {
            this._presetService.DeletePresetDocument(presetId, presetDocumentId);
        }
    }

    public showDetails(): void {
        this._presetService.showDetails(this.preset);
    }
}
